import { Fragment } from 'react';

import useNTRegistrationFunFacts from './UseNTRegistrationFunFacts';

import NTRegistrationLeftNav from '../components/leftNav/NTRegistrationLeftNav';
import NTRegistrationLoadingModal from '../components/dialogs/NTRegistrationLoadingModal';

import FunFactsFormGrid from '../../../components/grids/funFactsForm/FunFactsFormGrid';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import style from '../NTRegistration.module.css';

const NTRegistrationFunFacts = () => {
  const {
    isLoading,
    personId,
    gridData,
    onContinueClicked,
    onBackClicked,
    onSubmitFunFactsForm,
    updatePageHasUnsavedChanges,
    onNTRegistrationError
  } = useNTRegistrationFunFacts();

  return (
    <Fragment>
      <NTRegistrationLeftNav viewTitle={'Fun Facts'}>
        <FunFactsFormGrid
          gridData={gridData}
          personId={personId}
          onSubmitFormCallback={onSubmitFunFactsForm}
          onIsDirtyChanged={updatePageHasUnsavedChanges}
          onErrorCaught={onNTRegistrationError} />
        <div className={['row', style.PageNavigationButtons].join(' ')}>
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
            <PrimaryButton type="button" onClick={onContinueClicked}>Continue</PrimaryButton>
          </div>
        </div>
        <NTRegistrationLoadingModal isLoading={isLoading} />
      </NTRegistrationLeftNav>
    </Fragment>
  );
};

export default NTRegistrationFunFacts;